<app-form-basket
    [dataItem]="dataItem"
    [bskType]="bskType"
    [groupList]="groupList"
    [userList]="userList"
    (onValidate)="validate($event)"
    (onCancel)="cancel($event)"
    (onDelete)="delete($event)"
>
</app-form-basket>

